import { errorTextColor, successTextColor, warningTextColor } from '../../common/constants';

export class Qualities {
    private static list = [
        { icon: '&#xf00c;', color: successTextColor }, // OK
        { icon: '&#xf071;', color: warningTextColor }, // Warn
        { icon: '&#xf00d;', color: errorTextColor }, // Error
    ];

    static getColor(q: number) {
        return Qualities.list[q] ? Qualities.list[q].color : '';
    }

    static getIcon(q: number) {
        return Qualities.list[q] ? Qualities.list[q].icon : '';
    }
}
